import React, { useState } from "react";
import BusinessSearchNDetails from "../../../../../components/common/forms/BusinessSearchNDetails";
import { useForm } from "react-hook-form";
import Documents from "../../../../../components/common/forms/Documents";
import { v4 as uuidv4 } from "uuid";
import {
  upload_document,
  upload_document_v2,
} from "./Company_capital_increases";
import axios from "axios";
import FormBranch from "../../../../../components/common/forms/FormBranch";
import FormPayment from "../../../../../components/common/forms/FormPayment";
import FormButtom from "../../../../../components/common/forms/FormButtom";
import api, { url } from "../../../../../api/api";
import { toast } from "react-toastify";
import NewFormPayment from "../../../../../components/common/forms/NewFormPayment";


const OldCmpCapital = () => {
  const [cmpId, setCmpId] = useState(null);
  const { register, handleSubmit } = useForm();
  const [docsOutput, setDocsOutput] = useState([]);

  const [uploadProof, setUploadProof] = useState('')

  const handleClick = (data) => {
    // data.share_holders = shareHolders
    if (cmpId === null) {
      alert("First search company");
      return;
    }
    data.documents = docsOutput;
    data.company = cmpId;
    data.amendment_type = "capital_increase";
    console.log(data);

    const user = JSON.parse(localStorage.getItem("user"));


    api.post('services/company/amendments/', data)
      .then((response) => {
        toast.success("Data Registered Successfully")

        // let transactions = {
        //   // payment_mode: "e_wallet",
        //   amount: 2500,
        //   service_object_id: response.data.service_object_id,
        //   created_by: response.data.service_object_id,
        //   service_object_content_type: response.data.service_content_type_id,
        //   payment_proof : uploadProof,
        //   company : cmpId,
        //   transaction_type: "credit"

        // };


        // api
        // .post("/transactions/", transactions)
        // .then((response) => {
        //   toast.success("Data Registered 2 Successfully.");
        // })
        // .catch((error) => {
        //   toast.error("Error in Transaction");
        // });
      })
      .catch((error) => {
        // console.log("error", error);
        toast.error("Something went wrong")
      });


  };

  let data = [];
  upload_document.map((item, i) => {
    data.push({ id: uuidv4(), image: "", document_name: "" });
    return ''
  });

  return (
    <form>
      {/* company name and other details */}
      <BusinessSearchNDetails setCmpId={setCmpId} />
      {/* compnay name and other details close */}
      <div className="flex-col flex border-2 border-primary-blue font-Laila md:flex-row w-full overflow-x-auto my-3">
        <div className="   p-2 text-red-600 font-bold md:w-[350px]  md:border-r border-b md:border-b-0 border-primary-blue">
          अब परिवर्तन हुने शेयर पुँजीको विवरण

        </div>
        <div className="flex border-x-0 items-center md:w-[350px] md:border-r md:border-b-0 border-b flex-wrap  border-primary-blue">
          <p className="text-primary-red  items-center font-bold text-base">
            अधिकृत पुँजी :
          </p>
          <input className="outline-none  text-blue-600  md:w-[150px] pl-3 " type="" placeholder=""
            {...register("authorized_capital", { required: false })}
          />
        </div>
        <div className="flex flex-wrap  md:w-[300px] md:border-r md:border-b-0 border-b border-primary-blue">
          <p className="text-primary-red flex items-center font-bold text-base">
            जारी पुँजी :
          </p>
          <input className="outline-none  md:w-[100px]  text-blue-600  pl-3" type="text" placeholder=""
            {...register("issued_capital", { required: false })}
          />
        </div>
        <div className="flex flex-wrap md:w-[300px]   border-primary-blue">
          <p className="text-primary-red flex items-center font-bold text-base">
            चुक्ता पुँजी :
          </p>
          <input className="outline-none text-blue-600 md:w-[100px] pl-3 " type="text" placeholder=""
            {...register("paid_up_capital", { required: false })}
          />
        </div>
      </div>

      <div className="border-2 bg-pink-100 border-primary-blue ">
        <p className="text-primary-blue mt-0 text-lg font-semibold font-Laila leading-10 text-center">
          अब बृद्धि हुने अधिकृत पुँजीको आधारमा कम्पनीको पुँजी बृद्धि सम्बन्धि
          काम गर्दा तपाईको जम्मा लाग्ने रकम <span className="text-red-600">रु.१५,०००।–</span>  मात्र ।
        </p>
      </div>

      {/* upload documents open */}
      <div className="text-primary-blue font-Calistoga text-lg underline my-4">
        2. Upload Document
        <span className="text-primary-blue font-Laila underline">
          (शेयर लगत निकाल्नको लागि आवश्यक पर्ने निम्न कागजपत्रहरु ग्उयिबम
          गर्नुहोस ।)
        </span>
      </div>

      {/* upload documents close */}
      <Documents
        documents_data={upload_document}
        initialState={data}
        setDocument={setDocsOutput}
      />
      <div className="text-primary-blue font-Calistoga text-lg my-5 mb-6 underline">
        3. Working Branch
        <span className="text-primary-blue font-Laila underline mx-2 ">
          (तपाईले दर्ता गर्न खोज्नुभएको कम्पनी रहने ठेगाना नजिक हाम्रो कुन शाखा नजिक पर्छ छनोट गर्नुहोस् ।)
        </span>
      </div>

      <FormBranch register={register} name={"working_branch"} />
      <FormButtom />
      
      <NewFormPayment handleSubmit={handleSubmit} handleClick={handleClick}
        setUploadProof={setUploadProof}
      />

    </form>
  );
};

export default OldCmpCapital;
